import { combineReducers } from 'redux';
import { reducer as app } from './AppRedux';
import { reducer as auth } from './AuthRedux';
import { reducer as signup } from './SignupRedux';
import { reducer as booking } from './BookingRedux';
import { reducer as moveout } from './MoveoutRedux';
import { reducer as discontinue } from './DiscontinueRedux';
import { reducer as myCleans } from './CleansRedux';
import { reducer as properties } from './PropertyRedux';
import { reducer as schedule } from './ScheduleRedux';
import { reducer as subscription } from './SubscriptionRedux';
import { reducer as billingHistory } from './BillingHistoryRedux';
import { reducer as drag } from './DragRedux';

const reducers = combineReducers({
  app,
  auth,
  signup,
  booking,
  moveout,
  discontinue,
  myCleans,
  properties,
  schedule,
  subscription,
  billingHistory,
  drag
});

export default reducers;
